import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtGroup } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    setNotAssignedUserGroupSelected,
} from "client/store"
import {
    Default,
    UserIcon,
    TableColumn,
} from "client/components"

const Columns = () => {
    const selected = useSelector((state: StoreType) => state.userGroup.notAssignedGroups.selected)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const selectGroup = (group: MtGroup) => {
        let selectedCopy
        if (selected && selected.includes(group.id)) {
            selectedCopy = selected.filter((id) => (id !== group.id))
        } else {
            selectedCopy = selected ? deepCopy(selected) : []
            selectedCopy.push(group.id)
        }
        dispatch(setNotAssignedUserGroupSelected(selectedCopy))
    }

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
            onClick: selectGroup,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "150px",
            onClick: selectGroup,
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "500px",
            onClick: selectGroup,
        },
        {
            field: "creator",
            header: lang.createdBy,
            cellMinWidth: "150px",
            formatter: (group: MtGroup) => {
                if (group.accountId === 1) return <Default />
                return <UserIcon user={userList[group.creator]} size="sm" />
            },
            onClick: selectGroup,
        },
    ]

    return columns
}
export default Columns
